import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_remix_icon = _resolveComponent("remix-icon");
  return _openBlock(), _createElementBlock("span", null, [_createVNode(_component_remix_icon, {
    title: "重载路由",
    icon: "fas fa-sync",
    onClick: $options.refreshRoute
  }, null, 8, ["onClick"])]);
}